/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AICategoryMiniReference,
    AICategoryMiniReferenceFromJSON,
    AICategoryMiniReferenceFromJSONTyped,
    AICategoryMiniReferenceToJSON,
    AIImageReference,
    AIImageReferenceFromJSON,
    AIImageReferenceFromJSONTyped,
    AIImageReferenceToJSON,
} from './';

/**
 * 
 * @export
 * @interface AIAnnotationPartialUpdate
 */
export interface AIAnnotationPartialUpdate {
    /**
     * 
     * @type {AIImageReference}
     * @memberof AIAnnotationPartialUpdate
     */
    image?: AIImageReference;
    /**
     * 
     * @type {AICategoryMiniReference}
     * @memberof AIAnnotationPartialUpdate
     */
    category?: AICategoryMiniReference;
    /**
     * 
     * @type {number}
     * @memberof AIAnnotationPartialUpdate
     */
    relativeLeft?: number;
    /**
     * 
     * @type {number}
     * @memberof AIAnnotationPartialUpdate
     */
    relativeTop?: number;
    /**
     * 
     * @type {number}
     * @memberof AIAnnotationPartialUpdate
     */
    relativeWidth?: number;
    /**
     * 
     * @type {number}
     * @memberof AIAnnotationPartialUpdate
     */
    relativeHeight?: number;
    /**
     * 
     * @type {string}
     * @memberof AIAnnotationPartialUpdate
     */
    track?: string;
    /**
     * 
     * @type {number}
     * @memberof AIAnnotationPartialUpdate
     */
    createdBy?: number | null;
}

export function AIAnnotationPartialUpdateFromJSON(json: any): AIAnnotationPartialUpdate {
    return AIAnnotationPartialUpdateFromJSONTyped(json, false);
}

export function AIAnnotationPartialUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): AIAnnotationPartialUpdate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'image': !exists(json, 'image') ? undefined : AIImageReferenceFromJSON(json['image']),
        'category': !exists(json, 'category') ? undefined : AICategoryMiniReferenceFromJSON(json['category']),
        'relativeLeft': !exists(json, 'relative_left') ? undefined : json['relative_left'],
        'relativeTop': !exists(json, 'relative_top') ? undefined : json['relative_top'],
        'relativeWidth': !exists(json, 'relative_width') ? undefined : json['relative_width'],
        'relativeHeight': !exists(json, 'relative_height') ? undefined : json['relative_height'],
        'track': !exists(json, 'track') ? undefined : json['track'],
        'createdBy': !exists(json, 'created_by') ? undefined : json['created_by'],
    };
}

export function AIAnnotationPartialUpdateToJSON(value?: AIAnnotationPartialUpdate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'image': AIImageReferenceToJSON(value.image),
        'category': AICategoryMiniReferenceToJSON(value.category),
        'relative_left': value.relativeLeft,
        'relative_top': value.relativeTop,
        'relative_width': value.relativeWidth,
        'relative_height': value.relativeHeight,
        'track': value.track,
        'created_by': value.createdBy,
    };
}


